import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-user-feedback-popup',
  templateUrl: './user-feedback-popup.component.html',
  styleUrls: ['./user-feedback-popup.component.css']
})
export class UserFeedbackPopupComponent implements OnInit {
  assetName:any;
  assetData:any;
  reportOptions:any;
  selectedReportIds:any =[];
  userMessage:any;
  tempSelctedItems:any =[];
  constructor( @Inject(MAT_DIALOG_DATA) private data: any,
  private dialogRef: MatDialogRef<UserFeedbackPopupComponent>,private selfLearnSerice: SelfLearnService) { }

  ngOnInit(): void {
    this.assetName = this.data.assetType;
    this. getAssetTypes();
  }
 getAssetTypes(){
  this.selfLearnSerice.getAssetTypes().subscribe((res:any) =>{
    this.assetData = res.find((item:any) => item.assetName == this.assetName);
    this.getAssetReportOptions();
  })
 }
 getAssetReportOptions(){
  this.selfLearnSerice.getAssetReportOptions(this.assetData.assetTypeId).subscribe((res:any) =>{
  this.reportOptions = res;
  })
 }

 onValueChange(event: any) {
  this.userMessage = event.target.value
 }

  onConfirmClick(): void {
    this.reportOptions.map((item:any) => {
      if(item.checked)
      this.selectedReportIds.push(item.reportId)
    })

    let payLoad = {
      "assetTypeId": this.assetData.assetTypeId,
      "userReportOptionIds":  this.selectedReportIds,
      "assetId": this.data.assetId,
      "examId": this.selfLearnSerice.getCmsExamID(),
      "gradeId": this.selfLearnSerice.getGradeId(),
      "userMessage": this.userMessage ,
      "feedBack":  this.userMessage?.length > 0 ? true : false
    }
    this.selfLearnSerice.postAssetFeedBackReport(payLoad).subscribe((res:any) => {
    })
    this.dialogRef.close(true);
  }
 isUserSelectedChoice(event:any,report:any){
  console.log(event);
  if(event.checked){
  this.tempSelctedItems.push(report);
  }else{
    this.tempSelctedItems.pop(report);
  }
 }

}
